import { Controller } from "@hotwired/stimulus"

// FD-333: CSP-safe replacement for inline onclick="window.print()".
//   data-controller="print" data-action="click->print#print"
export default class extends Controller {
  print() {
    window.print()
  }
}
